import { observer } from 'mobx-react';
import * as React from 'react';
import { T, TPlainTextKey } from '../../Translations';
import CopyToClipboard from '../CopyToClipboard';

interface Props {
  label: TPlainTextKey;
  hint: React.ReactNode;
  value: string;
  monospaced: boolean;
}

// One labeled, copyable value in the "configure your IdP" packet.
const CopyRow: React.FC<Props> = ({ label, hint, value, monospaced }) => (
  <div className="flex items-center gap-3 border-b border-border px-4 py-3 last:border-b-0">
    <div className="w-44 shrink-0">
      <span className="block text-sm font-semibold text-foreground">
        <T kind={label} />
      </span>
      <span className="block text-xs text-muted-foreground">{hint}</span>
    </div>
    <span
      className={`min-w-0 flex-1 break-all text-sm text-foreground ${monospaced ? 'font-mono text-xs' : ''}`}
      data-testid="sso-copy-row-value"
    >
      {value}
    </span>
    <CopyToClipboard copyText={value} />
  </div>
);

export default observer(CopyRow);
